// extracted by mini-css-extract-plugin
export default {"footer":"_1LCdEXo6Ou","link":"VRYMcnisEk","version":"_1nwDDoTAaS","documentation":"_3WqIsrEgf6","claim":"U6gZYygsKU","right":"_21Lf9ro8LR"};
    if(module.hot) {
      // 1625219390579
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  